export type CaseClassification = {
  supportType?: string | null
  supportLine?: string | null
  isAnIncident?: boolean | null
}

export type CaseProfile = {
  caseDescription?: string | null
  caseOrigin?: string | null
  serviceLevelEncompassAgreement?: string | null
  severityJustification?: string | null
  stepsToRecreate?: string | null
}

export type CaseTracking = {
  dateTimeClosed?: string | null
  submissionDateTime?: string | null
}

export type ClosureDetails = {
  caseResolutionDescription?: string | null
  tempSolutionWorkaroundDescription?: string | null
  rejectionReason?: string | null
}

export type ProductAndSystems = {
  orderNumber?: string | null
  serialNumber?: string | null
  siteId?: string | null
}

export type CaseObject = {
  projectNumber?: string | null
  serviceAgreement?: string | null
  subject?: string | null
}

export type CaseDetailsApiResponse = {
  caseClassification?: CaseClassification | null
  caseProfile?: CaseProfile | null
  caseTracking?: CaseTracking | null
  closureDetails?: ClosureDetails | null
  productAndSystems?: ProductAndSystems | null
  case?: CaseObject | null
}

const PLACEHOLDER = '-'

export const formatDateTime = (iso?: string | null): string => {
  if (!iso) return PLACEHOLDER
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return PLACEHOLDER
  const datePart = date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
  const timePart = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
  return `${datePart} ${timePart}`
}

export const formatBool = (value?: boolean | null): string => {
  if (value === true) return 'Yes'
  if (value === false) return 'No'
  return PLACEHOLDER
}

export const stripHtml = (html?: string | null): string => {
  if (!html) return PLACEHOLDER
  try {
    const div = document.createElement('div')
    div.innerHTML = html
    return (div.textContent || '').trim() || PLACEHOLDER
  } catch {
    return PLACEHOLDER
  }
}

export const valueOrPlaceholder = (value?: string | null): string =>
  value && String(value).trim() !== '' ? value : PLACEHOLDER

export { PLACEHOLDER }
